export enum LoginCode {
  AVAILABLE = '0',
  NOT_CORRECT = '-1',
  NOT_AVAILABLE = '-2',
  CHANGE_PASSWORD = '20',
}
